export default "__VITE_ASSET__DCbw6om5__"